export default {"src":"/_next/static/media/mobile-icon.65905181.svg","height":513,"width":513};